import React from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/style/colors";
import { ReactComponent as AchieveAsset } from "../../assets/imgs/landingPage/achieve.svg";
import { ReactComponent as Asset2 } from "../../assets/imgs/fold4Asset2.svg";
import { ReactComponent as Asset3 } from "../../assets/imgs/fold4Asset3.svg";
import { useOutletContext } from "react-router-dom";
import { motion } from "framer-motion";
import BenefitCard from "./BenefitCard";
import AnimatedTextButton from "../generic/AnimatedTextButton";

const Fold4 = () => {
  return (
    <FullPageContainer>
      <Container id="benefits">
        <Line>
          <InfoTopic >
            <InfoTopicTitle>Achieve more with Grovs</InfoTopicTitle>
            <InfoTopicDescription>
              {" "}
              Grovs makes it simple to drive higher ROI, boost engagement, and
              increase conversions with ease.
            </InfoTopicDescription>
          </InfoTopic>
          <CardWrapper>
            <ImageContainer>
              <AchieveAsset style={{ width: "100%" }} />
            </ImageContainer>
          </CardWrapper>
        </Line>
      </Container>
    </FullPageContainer>
  );
};

export default Fold4;

const FullPageContainer = styled.div`
  display: flex;
  width: 100%;
  background: ${lightThemeColors.background};
  position: relative;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1512px;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: start;
padding:100px 80px;
  gap: 80px;
  @media (max-width: 990px) {
    padding: 20px;
    gap: 20px;
  }
`;

const CardWrapper = styled.div`
  display: flex;
  width: 100%;
  height: auto;
`;

const Line = styled.section`
  display: flex;
  align-items: center;
  gap: 25px;
  width: 100%;
  overflow: hidden;
  flex-direction: ${(props) => (props.reverse ? "row-reverse" : "initial")};

  @media (max-width: 990px) {
    gap: 10px;
    flex-direction: column;
  }
`;

const InfoTopic = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 30px;
`;
const InfoTopicTitle = styled.h3`
  color: ${lightThemeColors.darkColor};
  font-weight: 800;
  font-size: 36px;
  line-height: 50px;
  @media (max-width: 990px) {
    font-size: 30px;
    line-height: 36px;
    text-align: center;
  }
`;
const InfoTopicDescription = styled.p`
  color: ${lightThemeColors.darkColorFaded};
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  @media (max-width: 990px) {
    line-height: 24px;
    text-align: center;
  }
`;
const ImageContainer = styled.div`
  display: flex;
  justify-content: center; /* Horizontally centers the image */
  align-items: center; /* Vertically centers the image */
  width: 100%;
  height: 100%; /* Set height if needed for vertical centering */
  overflow: hidden;
  @media (max-width: 550px) {
    svg {
      height: 100%;
    }
  }
`;
